/**
 * Created by wuhuping on 2017/7/26.
 */
import JSBridge from './jsBridge'
import channel from './channel'
import remogeo from './remogeo'
import DeviceInfo from './deviceInfo'
export default {
  startLocation() {
    let map, geolocation
    // 加载地图，调用浏览器定位服务
    map = new window.AMap.Map('container', {
      resizeEnable: true
    })
    map.plugin('AMap.Geolocation', function () {
      geolocation = new window.AMap.Geolocation({
        enableHighAccuracy: true, // 是否使用高精度定位，默认:true
        timeout: 10000,          // 超过10秒后停止定位，默认：无穷大
        buttonOffset: new window.AMap.Pixel(10, 20), // 定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
        zoomToAccuracy: true,      // 定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
        buttonPosition: 'RB'
      })
      if (window.AMap.UA.ios) {
        // 使用远程定位，见 remogeo.js
        // 替换方法
        window.navigator.geolocation.getCurrentPosition = function () {
          return remogeo.getCurrentPosition.apply(remogeo, arguments);
        };
        // 替换方法
        window.navigator.geolocation.watchPosition = function () {
          return remogeo.watchPosition.apply(remogeo, arguments);
        };
      }
      map.addControl(geolocation)
      geolocation.getCurrentPosition()
      window.AMap.event.addListener(geolocation, 'complete', onComplete) // 返回定位信息
      window.AMap.event.addListener(geolocation, 'error', onError)       // 返回定位出错信息
    })
    // 解析定位结果
    function onComplete(data) {
      window.sessionStorage.setItem('userLongitude', data.position.getLng())
      window.sessionStorage.setItem('userLatitude', data.position.getLat())
    }

    // 解析定位错误信息
    function onError(data) {
      // 不做处理
    }
  },
  longitude(callback) {
    let isVersionLessThan113 = true;
    let deviceInfo = DeviceInfo.fetchDeviceInfo()
    if (deviceInfo) {
      deviceInfo = JSON.parse(deviceInfo)
      if (deviceInfo.appVersion && deviceInfo.appVersion >= '1.1.3') {
        isVersionLessThan113 = false;
      }
    }
    if (isVersionLessThan113) {
      callback(window.sessionStorage.getItem('userLongitude'))
    } else if (channel.isApp()) {
      JSBridge.checkUserAuthorization(function (isAuthorized) {
        if (isAuthorized) {
          callback(window.sessionStorage.getItem('userLongitude'))
        } else {
          callback('');
        }
      })
    } else {
      callback(window.sessionStorage.getItem('userLongitude'));
    }
  },
  longitudeSyc() {
    return window.sessionStorage.getItem('userLongitude') ? window.sessionStorage.getItem('userLongitude') : '';
  },
  latitude(callback) {
    let isVersionLessThan113 = true;
    let deviceInfo = DeviceInfo.fetchDeviceInfo()
    if (deviceInfo) {
      deviceInfo = JSON.parse(deviceInfo)
      if (deviceInfo.appVersion && deviceInfo.appVersion >= '1.1.3') {
        isVersionLessThan113 = false;
      }
    }
    if (isVersionLessThan113) {
      callback(window.sessionStorage.getItem('userLatitude'))
    } else if (channel.isApp()) {
      JSBridge.checkUserAuthorization(function (isAuthorized) {
        if (isAuthorized) {
          callback(window.sessionStorage.getItem('userLatitude'))
        } else {
          callback('');
        }
      })
    } else {
      callback(window.sessionStorage.getItem('userLatitude'));
    }
  },
  latitudeSyc() {
    return window.sessionStorage.getItem('userLatitude') ? window.sessionStorage.getItem('userLatitude') : '';
  }
}



// WEBPACK FOOTER //
// ./src/tools/locationHelper.js